import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  Instagram,
  Facebook,
  MessageSquare,
} from "lucide-react";
import { Link } from "react-router-dom";

const FooterSection = ({ title, children }) => (
  <div>
    <h3 className="text-xl font-bold mb-4" style={{ letterSpacing: "1px" }}>
      {title}
    </h3>
    {children}
  </div>
);

const ContactInfoItem = ({ Icon, text }) => (
  <p className="flex items-center text-gray-400">
    <p>
      <Icon className="h-5 w-5 mr-2" />
    </p>
    {text}
  </p>
);

const SocialLink = ({ Icon, href, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className="text-gray-400 hover:text-white"
  >
    <Icon className="h-6 w-6" />
  </a>
);

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2c3639] text-white py-10 pb-20">
      <div className="max-w-7xl mx-auto px-4  ">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <FooterSection title="ANS Safety Nets">
            <p className="text-gray-400">
              Providing high-quality safety nets and solutions for your
              protection needs.
            </p>
          </FooterSection>

          {/* Quick Links */}
          <FooterSection title="Quick Links">
            <ul className="space-y-2">
              {[
                { href: "/balconysafenets", label: "Balcony Safety Nets" },
                { href: "/invisiblegrills", label: "Invisible grills" },
                { href: "/childernsafetynets", label: "Children Safety Nets" },
                {
                  href: "/industrialsafetynets",
                  label: "Industrial Safety Nets",
                },
                { href: "/petssafetynets", label: "Pets Safety Nets" },
                { href: "/ducterianets", label: "Ducteria Nets" },
                { href: "/monkeysafetynets", label: "Monkey Safety Nets" },
                {
                  href: "/cricketpracticenets",
                  label: "Cricket Practice Nets",
                },
                { href: "/birdspikes", label: "Bird Spikes" },
                { href: "/blogs", label: "Our Blogs" },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </FooterSection>

          {/* Contact Info */}
          <FooterSection title="Contact Info">
            <div className="space-y-2">
              <ContactInfoItem
                Icon={Phone}
                text={
                  <a href="tel:+917416116587" className="hover:underline">
                    +91 7416116587
                  </a>
                }
              />

              <ContactInfoItem
                Icon={Mail}
                text={
                  <a
                    href="mailto:bengaluruanssafetynets3@gmail.com"
                    className="hover:underline"
                  >
                    bengaluruanssafetynets3@gmail.com
                  </a>
                }
              />
              <ContactInfoItem
                Icon={Mail}
                text={
                  <a
                    href="mailto:anssafetynets03@gmail.com"
                    className="hover:underline"
                  >
                    anssafetynets03@gmail.com
                  </a>
                }
              />

              <ContactInfoItem
                Icon={Mail}
                text={
                  <a
                    href="mailto:ansbengaluru01@gmail.com"
                    className="hover:underline"
                  >
                    ansbengaluru01@gmail.com
                  </a>
                }
              />
              <ContactInfoItem
                Icon={MapPin}
                text={
                  <a
                    href="https://maps.app.goo.gl/RHTB5CPEqmrinCji7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    373, 3rd Main Rd, near Panchamuki Ganesha temple, Anjanappa
                    Layout, Horamavu Banaswadi, Horamavu, Bengaluru, Karnataka
                    560113
                  </a>
                }
              />
            </div>
          </FooterSection>
        </div>

        {/* Social Media Links */}
        <div className="mt-8 text-center">
          <h3 className="text-lg font-bold mb-4">Follow Us On</h3>
          <div className="flex justify-center space-x-6">
            <SocialLink
              Icon={Instagram}
              href="https://www.instagram.com/anssafetynets/"
              label="Instagram"
            />
            <SocialLink
              Icon={Facebook}
              href="https://www.facebook.com/people/ANSsafetynets/61572534324956/"
              label="Facebook"
            />
            <SocialLink
              Icon={MessageSquare}
              href="https://wa.me/917416116587?text=Hi%20I%20would%20like%20to%20enquire%20about%20ANS%20Safety%20Nets%20from%20your%20website."
              label="WhatsApp"
            />
          </div>
        </div>

        <div className="border-t border-gray-400 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} ANS Safety Nets. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
